import { Grid } from '@chakra-ui/react'
import ComponentProps from '../../types/ComponentProps'

// Wrapper element for the top navigation bar
export const Main = ({
  className,
  theme = 'brand',
  children,
  ...props
}: ComponentProps) => {
  return (
    <Grid
      className={className}
      margin='auto'
      templateColumns='repeat(12, 1fr)'
      gap={6}
      p={6}
      backgroundColor={`${theme}.bg.primary`}
      textColor={`${theme}.text.secondary`}
      zIndex={10}
      pos='relative'
      {...props}
    >
      {children}
    </Grid>
  )
}
